enum TextAlignEnum {
    Auto = 0,
    Left = 1,
    Center = 2,
    Right = 3
}

enum ColumnResizingModeEnum {
    NextColumn = 0,
    Widget = 1
}

enum GroupingTypeEnum {
    SUM = 0,
    MIN = 1,
    MAX = 2,
    WSUM = 3,
    GROUP_BY = 4,
    NONE = 5,
    COUNT = 6,
    DSUM = 7,
    WDSUM = 8,
    TSUM = 9
}

enum FunctionTypeEnum {
    Normal = 0,
    PercentOfTotal = 1,
    Accumulated = 2,
    AccumulatedAll = 3,
    PercentOfRowTotal = 4,
    PercentOfRowGrandTotal = 5,
    PercentOfColumnTotal = 6,
    PercentOfColumnGrandTotal = 7,
    AbsoluteVariation = 8,
    PercentVariation = 9,
    Rank = 10,
}

enum TotalsPositionEnum {
    None = 0,
    Bottom = 1,
    Top = 2
}

enum ComparisonTypeEnum {
    None = 0,
    Value = 1,
    Variation = 2,
    PercentageVariation = 3
}

enum ReportTypeEnum {
    Analysis = 0,
    Pivot = 1,
    Chart = 2,
    None = 3
}

enum AutoGroupingEnum {
    None = 0,
    ByDay = 2,
    ByWeek = 3,
    ByMonth = 4,
    ByQuarter = 5,
    ByYear = 6,
    ByMonthOnly = 7,
    ByQuarterOnly = 8,
    ByWeekNumber = 9,
    ByWeekOnly = 10,
}

enum ColumnsWidthTypeEnum {
    Automatic = 0,
    Percentage = 1,
    Pixel = 2
}

enum CalculateTotalsEnum {
    UseFormula = 0,
    SumRows = 1
}

enum FieldFormatEnum {
    None = 0,
    Currency = 1,
    Numeric = 2,
    Percentage = 3,
    String = 4,
    Date = 5
}

enum TopBottomEnum {
    //None = 0,
    All = 1,
    Top = 2,
    Bottom = 3
}

enum FieldFormatStrEnum {
    None = "None",
    Currency = "Currency",
    Numeric = "Numeric",
    Percentage = "Percentage",
    String = "String",
    Date = "Date"
}

enum ComparisonDateOptionEnum {
    Manual = 0,
    Predefined = 1,
    Previous = 2
}

enum ComparisonDateUnitEnum {
    Year = 0,
    Quarter = 1,
    Month = 2,
    Week = 3,
    Day = 4
}

enum DataTypeEnum {
    NONE = 0,
    STRING = 1,
    NUMBER = 2,
    DATE = 3,
    BIT = 4,
    BOOL = 5
}

enum ComparisonMetricType {
    None, Value, Variation, PercentageVariation
}

enum PivotLayoutEnum {
    Horizontal = 0,
    Vertical = 1
}